module.exports = "/**\n* Import the colors and spacers from cf-design\n*/\n.icon-size {\n  font-size: 4rem;\n  color: #ddd;\n  font-weight: bold; }\n.error {\n  margin-top: 5rem !important; }\n@media only screen and (max-width: 767px) {\n  .error {\n    margin-top: 0rem !important; } }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/new-login-widget/mapdnative-app-msg/mapdnative-app-msg.component.scss
// module id = ./src/app/new-login-widget/mapdnative-app-msg/mapdnative-app-msg.component.scss
// module chunks = main